import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './components/Home.vue'
import User from './components/User.vue'
import Meetups from './components/Meetup/Meetups.vue'
import CreateMeetup from './components/Meetup/CreateMeetup.vue'
import Room from './components/Meetup/Room.vue'
import Slides from './components/Slider/Slides.vue'
import CreateSlide from './components/Slider/CreateSlide.vue'
import Orders from './components/Order/Orders.vue'
import CreateOrder from './components/Order/CreateOrder.vue'

Vue.use(VueRouter);

const routes = [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/meetups',
      name: 'meetups',
      component: Meetups
    },
    {
      path: '/meetups/new',
      name: 'createmeetup',
      component: CreateMeetup,
      meta: { requiresAuth: true }
    },
    {
      path: '/meetups/:room',
      name: 'room',
      component: Room
    },
    {
      path: '/user',
      name: 'user',
      component: User
    },
    {
      path: '/slides',
      name: 'slides',
      component: Slides,
    },
    {
      path: '/slides/new',
      name: 'createslide',
      component: CreateSlide,
      meta: { requiresAuth: true }
    },
    {
      path: '/orders',
      name: 'orders',
      component: Orders,
    },
    {
      path: '/orders/new/:room',
      name: 'createorder',
      component: CreateOrder
    },
  ];


const router = new VueRouter({
  routes,
  mode: 'history'
});


export default router;
